import React from 'react';

import { AddedAt } from './AddedAt';
import { ConnectedBadge, TwitterBadge } from './Badges';
import { TrashButton } from './TrashButton';

import { ConnectedTwitterCardWrapper, HandleText, LabelWrapper } from './styles';
interface Props {
    handle: string;
    addedDate: string;
    toggleShowDelete(): void;
}
export const ConnectedTwitterCard = ({ handle, addedDate, toggleShowDelete }: Props) => {
    return (
        <ConnectedTwitterCardWrapper>
            <TwitterBadge />
            <LabelWrapper>
                <HandleText>{handle}</HandleText>
                <AddedAt addedDate={addedDate} />
                <ConnectedBadge isMobile />
            </LabelWrapper>
            <ConnectedBadge />
            <TrashButton onClick={toggleShowDelete} />
        </ConnectedTwitterCardWrapper>
    );
};
